import React, { useEffect, useState } from 'react'
import BreadCrumbItem, { IBreadcrumbItem } from './BreadcrumbItem'
import Conditional from './Conditional'

export interface IBreadcrumbProps {
  items: IBreadcrumbItem[]
}

const Breadcrumbs = (props: IBreadcrumbProps) => {
  const [data, setData] = useState<IBreadcrumbItem[]>()
  useEffect(() => {
    setData(props.items)
  }, [props.items])

  return (
    <Conditional if={data && props.items.length > 0}>
      <nav className="breadcrumbs dnd-s-mob">
        <ol>
          {data?.map((item, key) => {
            return <BreadCrumbItem key={key} item={item} active={false} />
          })}
        </ol>
      </nav>
    </Conditional>
  )
}

export default Breadcrumbs
